<script>
  import RateMaterials from "./../RateMaterial/RateMaterials.svelte";
  import { scale } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import config from "../../../stores/config";
  import { Pulse } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let loading = true;
  let authData = { headers: { authorization: ls.get("jwt") } };

  export let show = false;
  export let title = "";

  export let embroidery;
  export let print;
  export let sublimation;

  export let styleID;

  let materialReq = null;

  const loadData = async () => {
    loading = true;

    axios
      .get(`${$config.backendURL}/fstyles/${styleID}`, authData)
      .then((res) => {
        materialReq = res.data.materialReq;
        embroidery = res.data.embroidery;
        print = res.data.print;
        sublimation = res.data.sublimation;

        console.log({ embroidery, print, sublimation });

        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dispatch = createEventDispatcher();

  const onClose = () => {
    dispatch("modalClose");
  };

  onMount(async () => {
    loadData();
  });

  $: {
    let data = { embroidery, print, sublimation };
    axios
      .put(`${$config.backendURL}/fstyles/${styleID}`, data, authData)
      .then((res) => console.log(res.data))
      .catch((err) => console.log(err));
  }
</script>

{#if show}
  <div
    on:click|self={onClose}
    class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/50"
    style="z-index: 999;"
  >
    <div
      transition:scale
      class="w-10/12 h-5/6 bg-gray-50 rounded-lg shadow-2xl py-4 px-5 border-t-2 border-green-400 overflow-auto"
    >
      <!-- Window title -->
      <div class="flex justify-between mb-4">
        <div class="flex items-center text-green-500">
          <i class="fas fa-lightbulb mr-2 text-xl" />
          <div class="uppercase tracking-widest text-base flex items-center">
            REQUIREMENTS FOR
            <div class="flex items-center mx-1 text-red-500">ONE</div>
            {title}
          </div>
        </div>
        <div class="flex items-center justify-center">
          <button class="btn btn-green" on:click={onClose}>
            <i class="fas fa-times-circle mr-2" />
            Close
          </button>
        </div>
      </div>

      <div class="flex mb-4">
        <div class="flex items-center mr-6">
          <input
            type="checkbox"
            bind:checked={embroidery}
            class="mr-2 rounded text-brand-strong-green"
          /> Embroidery
        </div>
        <div class="flex items-center mr-6">
          <input
            type="checkbox"
            bind:checked={print}
            class="mr-2 rounded text-brand-strong-green"
          /> Print
        </div>
        <div class="flex items-center">
          <input
            type="checkbox"
            bind:checked={sublimation}
            class="mr-2 rounded text-brand-strong-green"
          /> Sublimation
        </div>
      </div>

      <!-- Content -->
      <div class="">
        {#if loading}
          <div class="loading-screen h-screen flex items-center justify-center">
            <Pulse size="100" color="rgb(16, 185, 129)" unit="px" />
          </div>
        {:else}
          <div class="">
            <RateMaterials
              {styleID}
              {materialReq}
              on:reloadData={() => loadData()}
            />
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}
